<div class="otp-dialog-container">
  <h2 mat-dialog-title class="otp-dialog-header">
    <div class="otp-dialog-title">
      <div *ngIf="currentStep == 1">OTP sent</div>
      <div *ngIf="currentStep == 2">Verifying OTP</div>
    </div>
    <div class="otp-dialog-tip" style="margin-left: 18px;display: flex;flex-direction: row;gap: 8px">
      <div *ngIf="isVerifying">
        <mat-spinner color="primary" diameter="24"></mat-spinner>
      </div>
      <div *ngIf="isVerifying" class="error-message" style="margin-top: 5px;">Verifying...</div>
      <div *ngIf="showVerifyMsg" [ngClass]="verifySuccess ? 'success-message' : 'error-message'">{{verifyMsg}}</div>
    </div>
  </h2>

  <mat-dialog-content>
    <p class="otp-description">
      To ensure your account's security, we've sent an OTP to your mobile number {{maskedMobileNumber}}. Enter the code
      and click submit to finish signing in.
    </p>

    <div class="otp-input-container">
      <app-otp-input [value]="otpValues[0]" [index]="0" [focused]="true" [disabled]="isPaused || verifySuccess" (valueChange)="onValueChange($event)"
        (moveNext)="onMoveNext($event)" (movePrevious)="onMovePrevious($event)"
        (otpPaste)="onOtpPaste($event)"></app-otp-input>
      <app-otp-input [value]="otpValues[1]" [index]="1" [focused]="false" [disabled]="isPaused || verifySuccess" (valueChange)="onValueChange($event)"
        (moveNext)="onMoveNext($event)" (movePrevious)="onMovePrevious($event)"
        (otpPaste)="onOtpPaste($event)"></app-otp-input>
      <app-otp-input [value]="otpValues[2]" [index]="2" [focused]="false" [disabled]="isPaused || verifySuccess" (valueChange)="onValueChange($event)"
        (moveNext)="onMoveNext($event)" (movePrevious)="onMovePrevious($event)"
        (otpPaste)="onOtpPaste($event)"></app-otp-input>
      <app-otp-input [value]="otpValues[3]" [index]="3" [focused]="false" [disabled]="isPaused || verifySuccess" (valueChange)="onValueChange($event)"
        (moveNext)="onMoveNext($event)" (movePrevious)="onMovePrevious($event)"
        (otpPaste)="onOtpPaste($event)"></app-otp-input>
      <app-otp-input [value]="otpValues[4]" [index]="4" [focused]="false" [disabled]="isPaused || verifySuccess" (valueChange)="onValueChange($event)"
        (moveNext)="onMoveNext($event)" (movePrevious)="onMovePrevious($event)"
        (otpPaste)="onOtpPaste($event)"></app-otp-input>
      <app-otp-input [value]="otpValues[5]" [index]="5" [focused]="false" [disabled]="isPaused || verifySuccess" (valueChange)="onValueChange($event)"
        (moveNext)="onMoveNext($event)" (movePrevious)="onMovePrevious($event)"
        (otpPaste)="onOtpPaste($event)"></app-otp-input>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div style="display: flex; flex-direction: row; align-items: center; gap: 8px;">
      <!-- Show resend button when shouldResendOtp is true -->
      <button color="primary" *ngIf="shouldResendOtp" mat-button (click)="onResendOtp()" class="resend-btn" [disabled]="isVerifying || isPaused"> 
        Resend OTP <span *ngIf="isPaused"> ({{pauseRemainingSeconds}}s)</span>
      </button>
    </div>
    <div style="display: flex; flex-direction: row;justify-content: flex-end;">
      <button mat-button (click)="onCancel()" class="cancel-btn">Cancel</button>
      <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="isSubmitDisabled() || isPaused || verifySuccess" class="submit-btn">
        Submit
      </button>
    </div>
  </mat-dialog-actions>
</div>